import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from './config/api';
import logoAutomotor from './estilo/logo-automotor.png';
import logoAutomotorBlanco from './estilo/logo-automotor-blanco.png';
import JEmpleado from './components/JEmpleado';
import SFacompra from './components/SFacompra';
import SOrdencompra from './components/SOrdencompra';
import SRecepMateriales from './components/SRecepMateriales';
import CGCtrl from './components/CGCtrl';
import DPermisos from './components/DPermisos';
import CambiarClave from './components/CambiarClave';
import Kardex from './components/Kardex';
import BOPago from './components/BOPago';
import DashboardCtaPag from './components/DashboardCtaPag';
import OperacionesCajaBanco from './components/OperacionesCajaBanco';
import ChequesCartera from './components/ChequesCartera';
import EntregaFacturas from './components/EntregaFacturas';
import STransfer from './components/STransfer';
import TipoProducto from './components/TipoProducto';
import Grupo from './components/Grupo';
import Medida from './components/Medida';
import Marca from './components/Marca';
import Envase from './components/Envase';
import FamiliaProd from './components/FamiliaProd';
import LineaProd from './components/LineaProd';
import CatProd from './components/CatProd';
import Present from './components/Present';
import RubroProd from './components/RubroProd';
import CrearProducto from './components/Crearproducto';
import GestionProducto from './components/GestionProducto';
import CGCuenta from './components/CGCuenta';
import BBanco from './components/BBanco';
import CGSucursal from './components/CGSucursal';
import TDeposito from './components/TDeposito';
import TDivisiones from './components/TDivisiones';
import TFrangos from './components/TFrangos';
import TFPago from './components/TFPago';
import SOtromov from './components/SOtromov';
import SConsultaStk from './components/SConsultaStk';
import TGrupoCli from './components/TGrupoCli';
import TPais from './components/TPais';
import TCiudad from './components/TCiudad';
import TClascli from './components/TClascli';
import FCadenas from './components/FCadenas';
import TCanalcli from './components/TCanalcli';
import FVendedor from './components/FVendedor';
import FCliente from './components/FCliente';
import DFacRepar from './components/DFacRepar';
import FSorteos from './components/FSorteos';
import SorteoRuleta from './components/SorteoRuleta';
import SNRemision from './components/SNRemision';
import DashboardVentas from './components/DashboardVentas';
import CGAsientos from './components/CGAsientos';
import FFacturaVentas from './components/FFacturaVentas';
import BLiqRepar from './components/BLiqRepar';
import FPresupuesto from './components/FPresupuesto';
import Bienvenida from './components/Bienvenida';
import TTarjeta from './components/TTarjeta';
import FNCredito from './components/FNCredito';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';


function App() {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [token, setToken] = useState('');
  const [autenticado, setAutenticado] = useState(false);
  const [grupo, setGrupo] = useState('');
  const [menus, setMenus] = useState([]);
  const [menuAbierto, setMenuAbierto] = useState(true);
  const [submenuAbierto, setSubmenuAbierto] = useState({});
  const [pantalla, setPantalla] = useState('inicio');

  // Modo compacto: densidad reducida (paddings, tipografia mas chica).
  // Se persiste en localStorage.
  const [cambiarClaveAbierto, setCambiarClaveAbierto] = useState(false);
  const [modoCompacto, setModoCompacto] = useState(() => {
    return localStorage.getItem('modoCompacto') === '1';
  });

  // Logo dinamico de la empresa (desde /api/cgctrl/logo). Si no existe, fallback al estatico.
  // logoVersion = cache-buster: se refresca cuando CGCtrl emite el evento
  const [logoVersion, setLogoVersion] = useState(Date.now());
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoBg, setLogoBg] = useState('');   // color de fondo detras del logo
  const [nombreEmpresa, setNombreEmpresa] = useState('');  // cgctrl.empresa (para el titulo)
  useEffect(() => {
    let cancel = false;
    // HEAD del blob para saber si existe
    axios.head(getApiUrl('/api/cgctrl/logo'))
      .then(() => { if (!cancel) setLogoUrl(getApiUrl(`/api/cgctrl/logo?v=${logoVersion}`)); })
      .catch(() => { if (!cancel) setLogoUrl(null); });
    // Ademas leer el color de fondo y el nombre de la empresa desde el registro
    axios.get(getApiUrl('/api/cgctrl'), { validateStatus: s => s < 400 || s === 204 })
      .then(({ data, status }) => {
        if (cancel || status === 204 || !data) return;
        setLogoBg(data.logoBg || '');
        const emp = (data.empresa || '').trim();
        setNombreEmpresa(emp);
        // Titulo del tab del navegador
        document.title = emp ? `Newton ${emp}` : 'Newton PM';
      })
      .catch(() => {});
    return () => { cancel = true; };
  }, [logoVersion]);
  useEffect(() => {
    const h = () => setLogoVersion(Date.now());
    window.addEventListener('cgctrl-logo-updated', h);
    return () => window.removeEventListener('cgctrl-logo-updated', h);
  }, []);

  React.useEffect(() => {
    if (modoCompacto) {
      document.body.classList.add('modo-compacto');
      localStorage.setItem('modoCompacto', '1');
    } else {
      document.body.classList.remove('modo-compacto');
      localStorage.setItem('modoCompacto', '0');
    }
  }, [modoCompacto]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('Validando...');

    try {
      const response = await axios.post(getApiUrl('/api/auth/login'), {
        usuario: usuario,
        clave: clave
      });

      if (response.data.token) {
        setToken(response.data.token);
        setGrupo(response.data.grupo);
        setMenus(response.data.menus || []);
        setAutenticado(true);
        setMensaje('');
      }
    } catch (error) {
      if (error.response) {
        setMensaje(error.response.data.mensaje || 'Error en la autenticación');
      } else {
        setMensaje('Error de conexión con el servidor');
      }
      setAutenticado(false);
    }
  };

  const cerrarSesion = () => {
    setUsuario('');
    setClave('');
    setToken('');
    setGrupo('');
    setMenus([]);
    setAutenticado(false);
    setMensaje('');
    setMenuAbierto(true);
    setSubmenuAbierto({});
    setPantalla('inicio');
  };

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  const toggleSubmenu = (menuId) => {
    setSubmenuAbierto(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const navegarA = (url) => {
     console.log('Navegando a:', url); // AGREGAR ESTA LÍNEA
    setPantalla(url);
  };

  /**
   * Busca en el arbol de menus el item con la url dada y devuelve
   * la ruta completa de ancestros (para el breadcrumb).
   * Ej: ['Inventario', 'Operaciones', 'Notas de Envio']
   */
  const encontrarRutaMenu = (arbol, url, camino = []) => {
    for (const item of arbol) {
      const nuevoCamino = [...camino, item.descripcion];
      if (item.url === url) return nuevoCamino;
      if (item.submenus && item.submenus.length > 0) {
        const encontrado = encontrarRutaMenu(item.submenus, url, nuevoCamino);
        if (encontrado) return encontrado;
      }
    }
    return null;
  };

  // Ruta activa del breadcrumb (se recalcula cuando cambia la pantalla o los menus)
  const rutaBreadcrumb = React.useMemo(
    () => encontrarRutaMenu(menus || [], pantalla) || [],
    [menus, pantalla]
  );

  const renderMenu = (menu) => {
    const tieneHijos = menu.tieneHijos === 'S' && menu.submenus && menu.submenus.length > 0;
    
    return (
      <div key={menu.id}>
        <div 
          className={`menu-item ${tieneHijos ? 'menu-item-padre' : ''}`}
          onClick={() => {
            if (tieneHijos) {
              toggleSubmenu(menu.id);
            } else {
              navegarA(menu.url);
            }
          }}
        >
          <span>{menu.icono} {menu.descripcion}</span>
          {tieneHijos && (
            <span className="submenu-arrow">
              {submenuAbierto[menu.id] ? '▼' : '▶'}
            </span>
          )}
        </div>
        
        {tieneHijos && submenuAbierto[menu.id] && (
          <div className="submenu">
            {menu.submenus.map(submenu => renderMenu(submenu))}
          </div>
        )}
      </div>
    );
  };

  const renderContenido = () => {
  console.log('Pantalla actual:', pantalla);

  switch(pantalla) {
    case 'ttipoprod':
    case '/ttipoprod':
    case 'tipoprod':
      return <TipoProducto />;
    case 'tgrupo':  // AGREGAR ESTA LÍNEA
      return <Grupo />;  // Y ESTA
    case 'tmedida':  // AGREGAR ESTA LÍNEA
      return <Medida />;  // Y ESTA
    case 'tmarca':
      return <Marca />;
    case 'tenvase':
      return <Envase />;
    case 'tfamiliaprod':
      return <FamiliaProd />;
    case 'tlineaprod':
      return <LineaProd />;
    case 'tcatprod':
      return <CatProd />;
    case 'tpresent':
      return <Present />;
    case 'trubroprod':
      return <RubroProd />;
    /*case 'producto':  // AGREGAR ESTA LÍNEA
      return <CrearProducto />;  // Y ESTA
    case '/CrearProducto': */
    case 'producto':
     return <GestionProducto />;
    case 'cgcuenta':
      return <CGCuenta usuario={usuario} />;
    case 'bbanco':
      return <BBanco usuario={usuario} />;
    case 'cgsucursal':
      return <CGSucursal usuario={usuario} />;
    case 'tdeposito':
      return <TDeposito usuario={usuario} />;
    case 'tdivisiones':
      return <TDivisiones />;
    case 'tfrangos':
      return <TFrangos />;
    case 'tfpago':
      return <TFPago />;
    case 'sotromov':
      return <SOtromov usuario={usuario} />;
    case 'stransfer':
    case 'html/stk/otransfer.jsp':
    case 'html/stk/otransferencia.jsp':
      return <STransfer usuario={usuario} />;
    case 'sfacompra':
    case 'html/stk/osfacompra.jsp':
      return <SFacompra usuario={usuario} />;
    case 'sordencompra':
    case 'html/stk/osordencompra.jsp':
      return <SOrdencompra usuario={usuario} />;
    case 'srecepmateriales':
    case 'html/stk/osrecepmateriales.jsp':
      return <SRecepMateriales usuario={usuario} />;
    case 'cgctl':
    case 'cgctrl':
    case 'html/cg/ocgctrl.jsp':
      return <CGCtrl usuario={usuario} />;
    case 'dpermisos':
      return <DPermisos usuario={usuario} />;
    case 'kardex':
    case 'kardex-movimientos':
    case 'skardex':
    case 'html/stk/okardex.jsp':
      return <Kardex usuario={usuario} initialTab="movs" />;
    case 'kardex-stock-fecha':
      return <Kardex usuario={usuario} initialTab="stockFecha" />;
    case 'kardex-cierre':
      return <Kardex usuario={usuario} initialTab="cierre" />;
    case 'bopago':
    case 'html/bco/obopago.jsp':
      return <BOPago usuario={usuario} />;
    case 'operaciones-caja-banco':
    case 'html/bco/ooperaciones.jsp':
      return <OperacionesCajaBanco usuario={usuario} />;
    case 'cheques-cartera-cliente':
    case 'html/ctacob/rptLisChequesenCarteraXCliente.jsp':
      return <ChequesCartera usuario={usuario} />;
    case 'entrega_facturas':
      return <EntregaFacturas usuario={usuario} />;
    case 'dashboardctapag':
    case 'html/ctapag/odashboardctapag.jsp':
      return <DashboardCtaPag usuario={usuario} />;
    case 'sconsultastk':
      return <SConsultaStk />;
    case 'tgrupocli':
      return <TGrupoCli />;
    case 'tpais':
      return <TPais />;
    case 'tciudad':
      return <TCiudad />;
    case 'tclascli':
      return <TClascli />;
    case 'fcadenas':
      return <FCadenas />;
    case 'tcanalcli':
      return <TCanalcli />;
    case 'fvendedor':
      return <FVendedor usuario={usuario} />;
    case 'fcliente':
      return <FCliente usuario={usuario} />;
    case 'dfacrepar':
      return <DFacRepar usuario={usuario} />;
    case 'fsorteos':
      return <FSorteos />;
    case 'fsortear':
      return <SorteoRuleta />;
    case 'snremision':
    case 'html/vta/oremcli.jsp':
      return <SNRemision usuario={usuario} />;
    case 'ventas':
      return <DashboardVentas />;
    case 'html/cg/oasientos.jsp':
      return <CGAsientos />;
    case 'bliqrepar':
      return <BLiqRepar usuario={usuario} />;
    case 'html/rrhh/jempleado.jsp':
    case 'jempleado':
      return <JEmpleado />;
    case 'html/vta/ofacturaventas.jsp':
      return <FFacturaVentas usuario={usuario} />;
    case 'html/vta/opresupuestoscli.jsp':
      return <FPresupuesto usuario={usuario} />;
    case 'ttarjeta':
      return <TTarjeta usuario={usuario} />;
    case 'fncredito':
      return <FNCredito usuario={usuario} />;
    case 'inicio':
    default:
      return <Bienvenida usuario={usuario} grupo={grupo} />;
  }
};

  // Usuario autenticado pero sin ninguna opcion de menu (sin grupo ni permisos): no se muestra nada del sistema
  if (autenticado && menus.length === 0) {
    return (
      <div className="app-container">
        <div className="sin-acceso">
          <div className="sin-acceso-caja">
            <img src={logoUrl || logoAutomotor} onError={(e) => { e.currentTarget.src = logoAutomotor; }} alt="Empresa" className="logo-img" />
            <h2>Sin acceso asignado</h2>
            <p>El usuario <strong>{usuario}</strong> no pertenece a ningun grupo ni tiene permisos asignados,
               por lo que no puede ingresar a ninguna opcion del sistema.</p>
            <p>Solicite al administrador que le asigne un grupo o permisos y vuelva a iniciar sesion.</p>
            <button onClick={cerrarSesion} className="logout-button">Cerrar Sesión</button>
          </div>
        </div>
      </div>
    );
  }

  if (autenticado) {
    return (
      <div className="app-container">
        <ToastContainer position="top-right" autoClose={3000} />
        <header className="app-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button onClick={toggleMenu} className="menu-button">
              ☰
            </button>
            <span style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                background: logoBg || 'transparent',
                padding: logoBg ? '2px 6px' : 0,
                borderRadius: logoBg ? '4px' : 0
              }}>
              <img src={logoUrl || logoAutomotorBlanco}
                   onError={(e) => { e.currentTarget.src = logoAutomotorBlanco; }}
                   alt="Empresa" className="app-header-logo" />
            </span>
          </div>
          <h1 className="app-title">Newton {nombreEmpresa || 'PM'}</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button
              onClick={() => setModoCompacto(v => !v)}
              className="toggle-compacto"
              title={modoCompacto ? 'Cambiar a modo estandar' : 'Cambiar a modo compacto (mas denso)'}>
              {modoCompacto ? '🔍 Estandar' : '📏 Compacto'}
            </button>
            <button onClick={() => setCambiarClaveAbierto(true)} className="toggle-compacto" title="Cambiar mi contrasena">
              🔑 Mi clave
            </button>
            <button onClick={cerrarSesion} className="logout-button">
              Cerrar Sesión
            </button>
          </div>
        </header>
        {cambiarClaveAbierto && <CambiarClave usuario={usuario} onCerrar={() => setCambiarClaveAbierto(false)} />}

        <div className="main-container">
          {menuAbierto && (
            <aside className="sidebar">
              {menus.map(menu => renderMenu(menu))}
              
              <div className="menu-item-footer">
                <strong>Usuario:</strong> {usuario}
                <br />
                <strong>Grupo:</strong> {grupo}
              </div>
            </aside>
          )}

          <main className={menuAbierto ? "content content-with-menu" : "content"}>
            {/* Sub-header contextual: breadcrumb del menu activo */}
            {rutaBreadcrumb.length > 0 && (
              <nav className="breadcrumb" aria-label="Ruta de navegacion">
                <span className="breadcrumb-home" onClick={() => setPantalla('inicio')} title="Ir al inicio">
                  🏠 Inicio
                </span>
                {rutaBreadcrumb.map((nombre, i) => (
                  <React.Fragment key={i}>
                    <span className="breadcrumb-sep">›</span>
                    <span className={i === rutaBreadcrumb.length - 1 ? 'breadcrumb-actual' : 'breadcrumb-padre'}>
                      {nombre}
                    </span>
                  </React.Fragment>
                ))}
              </nav>
            )}
            {renderContenido()}
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <span className="login-deco-1" aria-hidden="true"></span>
      <span className="login-deco-2" aria-hidden="true"></span>
      <span className="login-deco-3" aria-hidden="true"></span>
      <div className="login-box">
        <div className="login-logo" style={{
          background: logoBg || 'transparent',
          padding: logoBg ? '10px' : 0,
          borderRadius: logoBg ? '8px' : 0,
          display: 'inline-block'
        }}>
          <img src={logoUrl || logoAutomotor}
               onError={(e) => { e.currentTarget.src = logoAutomotor; }}
               alt="Empresa" className="logo-img" />
        </div>
        <p className="login-subtitle">Iniciar Sesión</p>
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Usuario</label>
            <input
              type="text"
              placeholder="Ingrese su usuario"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Contraseña</label>
            <input
              type="password"
              placeholder="Ingrese su contraseña"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-login">
            Ingresar
          </button>
        </form>

        {mensaje && (
          <div className="mensaje error">
            {mensaje}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;